import type { ReactNode } from 'react';
import './ui.css';

interface CardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  actions?: ReactNode;
}

export function Card({ title, subtitle, children, className = '', actions }: CardProps) {
  return (
    <section className={`ui-card ${className}`.trim()}>
      {(title || actions) && (
        <header className="ui-card__header">
          <div>
            {title ? <h2 className="ui-card__title">{title}</h2> : null}
            {subtitle ? <p className="ui-card__subtitle">{subtitle}</p> : null}
          </div>
          {actions}
        </header>
      )}
      <div className="ui-card__body">{children}</div>
    </section>
  );
}

interface StatCardProps {
  label: string;
  value: string;
  hint?: string;
}

export function StatCard({ label, value, hint }: StatCardProps) {
  return (
    <div className="ui-stat">
      <span className="ui-stat__label">{label}</span>
      <strong className="ui-stat__value">{value}</strong>
      {hint ? <span className="ui-stat__hint">{hint}</span> : null}
    </div>
  );
}
